import type { MediaType } from '@/features/media/types'
import { API_BASE, apiSlice } from '@/redux/api-slice'
import type {
  BulkFieldsResponse,
  PerformBulkEditRequest,
  UserCanBulkEditModel,
} from './types'

const url = API_BASE + 'MediaBulk'

export const bulkEditApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getBulkFields: build.query<BulkFieldsResponse, MediaType>({
      query: (mediaType: MediaType) => ({
        url: `${url}/bulkFields/`,
        params: { mediaType },
      }),
      providesTags: ['BulkFields'],
    }),
    getUserCanBulkEdit: build.query<boolean, UserCanBulkEditModel>({
      query: (body) => ({
        method: 'POST',
        url: `${url}/userCanBulkEdit`,
        body: body,
      }),
    }),
    performMediaBulkEdit: build.mutation<void, PerformBulkEditRequest>({
      query: (body) => ({
        method: 'POST',
        url: `${url}/performMediaBulkEdit`,
        body: body,
      }),
    }),
  }),
})

export const {
  useGetBulkFieldsQuery,
  useGetUserCanBulkEditQuery,
  usePerformMediaBulkEditMutation,
} = bulkEditApi
